module.exports = __webpack_public_path__ + "static/img/4.401a6c44.png";